import * as d3 from "d3"
import { timing } from "./nexusConfig"
import { getYearsAndMonths, getNameProp } from "../../../modules/utilities"
import { TIMELINE } from "../../../modules/constants"

let showingConnectionInfo = false

export const timelineInfoLayout = {
  maxWidth: 320,
  maxHeight: 220,
  xPadding: 12,
  yPadding: 3,
  xMargin: 18,
  cornerRadiusFactor: 0.02,
  opacity: 0.9,
  fontSize: 14,
  maxNameLength: 33,
  textColor: "white",
}

export const showTimelineTooltip = ({ d, nexus, event }) => {
  if (showingConnectionInfo)
    return
  // console.log("d: ", d)

  // console.log("showConnectionInfo")
  showingConnectionInfo = true

  const connectionInfo = getTimelineInfoDimensions({ event, nexus })

  // create connection info group
  nexus.connectionInfoGroup = d3.select(".nexus")
    .append("g")
    .attr("class", "connection-info")
    .attr("transform", "translate(" + connectionInfo.x + "," + connectionInfo.y + ")")

  // create connection info background
  nexus.connectionInfoGroup.background = nexus.connectionInfoGroup.append("rect")
    .attr("class", "connection-info-background")
    .attr("pointer-events", "none")
    .attr("cursor", "pointer")
    .attr("x", 0)
    .attr("y", 0)
    .attr("width", connectionInfo.width)
    .attr("height", connectionInfo.height)
    .attr("rx", 10)
    .attr("ry", 10)
    .attr("fill", "#444444")
    .attr("stroke", timelineInfoLayout.color)
    .style("opacity", 0)
    .transition()
    .delay(TIMELINE.TOOLTIP_DELAY)
    .style("opacity", timelineInfoLayout.opacity)

  // create connection info text
  d3.select(".connection-info")
    .append("foreignObject")
    .attr("class", "connection-info-text")
    .attr("pointer-events", "none")
    .attr("transform", "translate(" + (timelineInfoLayout.xPadding) + "," + (timelineInfoLayout.yPadding) + ")")
    .attr("width", `${connectionInfo.width - (timelineInfoLayout.xPadding * 2)}`)
    .attr("height", 100) // `${connectionInfo.height - (timelineInfoLayout.yPadding * 2)}`)
    .attr("color", timelineInfoLayout.textColor)
    .html(getTimelineInfoText({ d, nexus }))
    .attr("font-size", timelineInfoLayout.fontSize)
    .style("opacity", 0)
    .transition()
    .delay(TIMELINE.TOOLTIP_DELAY)
    .style("opacity", timelineInfoLayout.opacity)

  return
}

export const moveTimelineTooltip = ({ event, nexus }) => {
  if (!showingConnectionInfo)
    return

  const connectionInfo = getTimelineInfoDimensions({ event, nexus })

  nexus.connectionInfoGroup
    .transition()
    .duration(timing.fast)
    .attr("transform", "translate(" + connectionInfo.x + "," + connectionInfo.y + ")")
}

export const hideTimelineTooltip = () => {
  showingConnectionInfo = false

  d3.selectAll(".connection-info").remove()
  d3.selectAll(".connection-info-background").remove()
  d3.select(".connection-info-text").remove()
}

const getTimelineInfoText = ({ d, nexus }) => {
  // if necessary, shorten name to fit in tooltip box
  const tipName = abridgeString(getNameProp.toPresent(d.entity.name), timelineInfoLayout.maxNameLength)

  let text = `<p class="connection-info-p"><strong>${tipName}</strong><br>`
  if (d.role?.days) text += nexus.secondLevel
    ? `Overlap ${getYearsAndMonths(d.role.from, d.role.until)} - `
    : `Tenure ${getYearsAndMonths(d.role.from, d.role.until)} - `

  text += !nexus.secondLevel
    ? "click for more info" // a corporate officer
    : "click for connections" // showing second level connections
  text += "</p>"

  return text
}

const abridgeString = (inputStr, maxLength) => inputStr.length > maxLength
  ? `${inputStr.substring(0, maxLength)}...`
  : inputStr

const getTimelineInfoDimensions = ({ event, nexus }) => {
  const connectionInfo = {
    width: Math.min(timelineInfoLayout.maxWidth, nexus.width - (timelineInfoLayout.xMargin * 2)),
    height: TIMELINE.ROW_HEIGHT
  }

  // find cursor x coordinate
  let cursorX = event.pageX - nexus.svgX

  connectionInfo.x = cursorX < nexus.width / 2
    ? cursorX + 10 // position tooltip to right of cursor
    : cursorX - connectionInfo.width - 10 // position to left of cursor

  // find y coordinate
  nexus.top = document.getElementById("timeline-div").getBoundingClientRect().top
  const svgTop = document.getElementById("svg").getBoundingClientRect().top

  const cursorY = event.pageY - nexus.top // y coordinate within nexus window

  connectionInfo.y = nexus.top + (TIMELINE.ROW_HEIGHT * Math.floor((cursorY - svgTop) / TIMELINE.ROW_HEIGHT)) - 5

  return connectionInfo
}
